<template>
  <div class="ViewControler" v-show="visible">
    <Icon type="big" name="icon-one" v-show="!isLoop" content="循环播放" @click="setLoop(true)"></Icon>
    <Icon type="big" name="icon-cycle1" v-show="isLoop" content="取消循环" @click="setLoop(false)"></Icon>
    <div class="playDivider"></div>
    <Icon class="playBtn" type="big" name="icon-suspend" v-show="!isPlaying" content="播放" @click="play"></Icon>
    <Icon class="playBtn" type="big" name="icon-play1" v-show="isPlaying" content="暂停" @click="pause"></Icon>
    <div class="playDivider"></div>
    <Icon type="big" name="icon-tuichu1" content="退出" @click="close"></Icon>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ViewControler',
  computed: {
    ...mapGetters(['isRightDrawVisible'])
  },
  data () {
    return {
      visible: false,
      isPlaying: false,
      isLoop: false,
      isLastShowRight: false
    }
  },
  methods: {
    show (data) {
      this.visible = true
      this.isLastShowRight = this.isRightDrawVisible
      this.$store.dispatch('showRight', false)
      this.$store.dispatch('showLeft', false)
      this.flyData = JSON.parse(JSON.stringify(data))
      this.addPointRoute(this.flyData)
    },
    addPointRoute (data) {
      const flyRoute = new CesiumPlus.FlyRoute(this.$cesiumPlus.viewer, {
        pitch: -30,
        isFlyLoop: this.isLoop
      })
      this.$cesiumPlus.flyManager.route = flyRoute
      for (let i = 0; i < data.viewpoints.length; i++) {
        const position = data.viewpoints[i].viewpoint.view.cameraPosition
        const routeStop = new CesiumPlus.RouteStop({
          point: Cesium.Cartesian3.fromDegrees(position[0], position[1], position[2]),
          heading: data.viewpoints[i].viewpoint.view.cameraHeading,
          pitch: data.viewpoints[i].viewpoint.view.cameraPitch,
          roll: data.viewpoints[i].viewpoint.view.cameraRoll,
          waitTime: 1,
          duration: data.viewpoints[i].duration
        })
        flyRoute.addStop(routeStop)
      }
      this.$cesiumPlus.flyManager.play(() => {
        this.isPlaying = false
      })
      this.isPlaying = true
    },
    pause () {
      this.$cesiumPlus.flyManager.pause()
      this.isPlaying = false
    },
    play () {
      if (this.$cesiumPlus.flyManager.isPause()) {
        this.$cesiumPlus.flyManager.resume()
      } else {
        this.$cesiumPlus.flyManager.play(() => {
          this.isPlaying = false
        })
      }

      this.isPlaying = true
    },
    stop () {
      this.isPlaying = false
      this.isLoop = false
      this.$cesiumPlus.flyManager.stop()
    },
    setLoop (isLoop) {
      this.$cesiumPlus.flyManager.route.isFlyLoop = isLoop
      this.isLoop = isLoop
    },
    close () {
      this.stop()
      if (this.isLastShowRight) {
        this.$store.dispatch('showRight', true)
      }

      this.$store.dispatch('showLeft', true)
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.ViewControler{
  position: absolute;
  bottom: 30px;
  left: calc((100% - 241px)/2);
  display: flex;
  width: 241px;
  height: 50px;
  background: rgba($color: #000000, $alpha: 0.7);
  box-shadow: 1px 4px 6px 0px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  align-items: center;
  padding: 0 30px;
  .playDivider{
    width: 1px;
    height: 30px;
    background: #000000;
    // border: 1px solid #030B1A;
    margin: 0 16px;
  }
  .playBtn{
    height: 50px;
    width: 50px;
    svg{
      font-size: 36px;
    }
  }
}
</style>
